import { AppState } from '../../store/appState';
import { useSelector } from 'react-redux';

export function useAuthentication() {
    return useSelector((state: AppState) => state.authentication);
}
